import Contact from "../components/site/Contact";

export default function ContactPage() {
  return (
    <div className="pt-24">
      <Contact />
    </div>
  );
}
